// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import dice6Icon from "@/assets/icons/dice-6.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Dice6IconProps = Omit<IconProps, "name">;

export function Dice6Icon(props: Dice6IconProps): React.ReactNode {
  return <Icon name={dice6Icon} {...props} />;
}
